import React from 'react';

import { SvgComponent } from '@/types/modules/svg.types';

export const ListArrowUp: SvgComponent = (props) => (
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path d="M8 14L12 10L16 14" stroke="currentColor" strokeWidth="2" />
	</svg>
);
